<template>
  <transition name="sticky" @after-enter="slideInContent">
    <div class="sticky-contact" v-if="showSticky" @click="openContactSlidein">
      <div class="sticky-contact__inner">
        <transition name="contentbox">
          <div
            class="sticky-contact__content"
            :class="showContent ? 'show-content' : ''"
          >
            <div
              class="sticky-contact__text"
              :class="showText ? 'show-text' : ''"
            >
              <div class="sticky-contact__text-label">{{ title }}</div>
              <div class="sticky-contact__text-name">{{ text }}</div>
            </div>
          </div>
        </transition>
        <div class="sticky-contact__circle">
          <div class="sticky-contact__icon">
            <letter-icon></letter-icon>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import LetterIcon from "-!vue-svg-loader!../../images/icon-letter.svg";

export default {
  name: "StickyContact",
  components: {
    LetterIcon,
  },
  props: {
    title: String,
    text: String,
  },
  data: () => ({
    show: false,
    showContent: false,
    showText: false,
    lastScrollTop: 0,
  }),
  computed: {
    showSticky() {
      if (this.show && !this.hide) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    slideInContent() {
      if (window.innerWidth > 767) {
        this.showContent = true;
        setTimeout(() => {
          this.showText = true;
        }, 300);
      }
    },
    onScroll() {
      if (window.innerWidth > 767) {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          this.showText = false;
          this.showContent = false;
        } else {
          this.slideInContent();
        }
        this.lastScrollTop = st <= 0 ? 0 : st;
      }
    },
    openContactSlidein() {
      this.$emit("please-open");
    },
  },
  mounted() {
    this.show = true;
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.sticky-contact {
  bottom: 20px;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  flex-flow: row wrap;
  justify-content: space-evenly;
  position: fixed;
  right: 20px;
  z-index: 4;

  &__inner {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    height: 80px;
    width: 100%;

    &:hover {
      .sticky-contact__circle {
        background-color: $brand-dark-blue;
      }
      .sticky-contact__text {
        border-color: $brand-dark-blue;
      }
    }
  }

  &__content {
    align-items: flex-end;
    display: flex;
    flex-flow: row wrap;
    height: 80px;
    position: relative;
    max-width: 80px;
    transition: max-width 800ms $t-nice;
    border-radius: 80px;
    overflow: hidden;
  }

  &__text {
    font-size: 14px;
    line-height: 19px;
    padding-left: 20px;
    padding-right: 75px;
    margin-right: 10px;
    margin-left: 15px;
    border: 3px solid $brand-orange;
    height: 63px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 80px;
    transition: opacity 400ms $t-nice, margin-left 400ms $t-nice,
      border-color 300ms $t-nice;
    background: #fff;
    box-shadow: 0px 0px 6px #00000033;

    &-label {
      font-weight: 500;
    }

    &-label,
    &-name {
      opacity: 0;
    }
  }

  &__circle {
    align-items: center;
    background-color: $brand-orange;
    border-radius: 50%;
    display: flex;
    height: 80px;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    transition: transform 400ms $t-nice, background-color 300ms $t-nice;
    width: 80px;
    z-index: 110;
    box-shadow: 0px 0px 4px #00000034;
  }

  &__icon {
    line-height: 0;
  }
}

@media all and (max-width: 767px) {
  .sticky-contact {
    bottom: 10px;
    right: 10px;
  }
}

// Transitions

// Root fade-in
.sticky-enter-active {
  animation: sticky-coming 1s;
  transition: $t-nice;
}

@keyframes sticky-coming {
  0% {
    opacity: 0;
    width: 90px;
  }

  40% {
    opacity: 0;
    width: 90px;
  }

  100% {
    opacity: 1;
    width: 90px;
  }
}

.sticky-contact {
  &__content {
    &.show-content {
      max-width: 600px;
      border-radius: 0 80px 80px 0;
    }
  }

  .show-text {
    margin-left: 0;
    .sticky-contact__text-label,
    .sticky-contact__text-name {
      opacity: 1;
    }
  }
}
</style>
